// PayFast Configuration - NO MORE SECRETS IN FRONTEND!
// All secrets are now secured in WordPress functions.php
export const PAYFAST_CONFIG = {
  // URLs only (no secrets)
  SANDBOX_URL: 'https://sandbox.payfast.co.za/eng/process',
  PRODUCTION_URL: 'https://www.payfast.co.za/eng/process',
  RETURN_URL: import.meta.env?.VITE_PAYFAST_RETURN_URL || process.env.REACT_APP_PAYFAST_RETURN_URL || (typeof window !== 'undefined' ? window.location.origin + '/payment/success' : ''),
  CANCEL_URL: import.meta.env?.VITE_PAYFAST_CANCEL_URL || process.env.REACT_APP_PAYFAST_CANCEL_URL || (typeof window !== 'undefined' ? window.location.origin + '/payment/failure' : ''),
  NOTIFY_URL: import.meta.env?.VITE_PAYFAST_NOTIFY_URL || process.env.REACT_APP_PAYFAST_NOTIFY_URL || '',
  TEST_MODE: (import.meta.env?.VITE_PAYFAST_TEST_MODE || process.env.REACT_APP_PAYFAST_TEST_MODE || 'true') === 'true',
};

// WooCommerce Configuration - NO MORE SECRETS IN FRONTEND!
// All WooCommerce API calls now go through secure WordPress endpoints
export const WOOCOMMERCE_CONFIG = {
  BASE_URL: import.meta.env?.VITE_WORDPRESS_URL || process.env.REACT_APP_WORDPRESS_URL || '',
  API_VERSION: 'oracle/v1', // Changed from 'wc/v3' to secure WordPress endpoint
  // REMOVED: CONSUMER_KEY and CONSUMER_SECRET - now handled by WordPress backend
  PRODUCTS_PER_PAGE: 12,
  TIMEOUT: 10000,
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000,
  CACHE_DURATION: 5 * 60 * 1000,
};

export const API_ENDPOINTS = {
  PRODUCTS: '/products',
  PRODUCT: (id) => `/products/${id}`,
  CATEGORIES: '/products/categories',
  ORDERS: '/orders',
  ORDER: (id) => `/orders/${id}`,
  PAYFAST_PROCESS: (PAYFAST_CONFIG.TEST_MODE ? PAYFAST_CONFIG.SANDBOX_URL : PAYFAST_CONFIG.PRODUCTION_URL),
};

export const DEFAULTS = {
  COUNTRY: 'ZA',
  CURRENCY: 'ZAR',
  PAYMENT_METHOD: 'payfast',
  CART_STORAGE_KEY: 'oracle-gaming-cart',
  PAGE: 1,
  PER_PAGE: 12,
};

// Shipping Configuration - SINGLE SOURCE OF TRUTH
// These values must match the rates configured in the Bob Go dashboard.
// Bob Go is authoritative for the live "Shipping to Address" rate; the values
// here are the fallbacks used when the Bob Go API is unreachable, plus the
// rates for the methods Bob Go does not price (store collection, PUDO locker).
export const SHIPPING_CONFIG = {
  // Free shipping kicks in at this cart subtotal
  FREE_SHIPPING_THRESHOLD: parseFloat(process.env.REACT_APP_FREE_SHIPPING_THRESHOLD || '1899'),
  // Standard door-to-door courier rate (mirrors Bob Go "Standard shipping")
  STANDARD_RATE: parseFloat(process.env.REACT_APP_STANDARD_SHIPPING_RATE || '119'),
  // PUDO locker rate - priced by us, not by Bob Go
  PUDO_RATE: parseFloat(process.env.REACT_APP_PUDO_SHIPPING_RATE || '99'),
  // Express shipping has been retired. Any rate Bob Go returns whose service
  // name matches this is filtered out before it reaches the customer.
  EXCLUDED_SERVICE_PATTERN: /express|same[\s-]?day|overnight/i,
};

// Pre-order Configuration
// Products carrying this WooCommerce tag show a "Pre Order" button instead of
// "Add to Cart", and can be ordered regardless of their stock status.
export const PRE_ORDER_TAG = 'pre-order';

export const ERROR_MESSAGES = {
  API_ERROR: 'API request failed. Please try again.',
  NETWORK_ERROR: 'Network error. Please check your connection.',
  ORDER_CREATION_FAILED: 'Failed to create order. Please try again.',
  PAYMENT_FAILED: 'Payment failed. Please try again.',
};

export const SUCCESS_MESSAGES = {
  ORDER_CREATED: 'Order created successfully.',
  PAYMENT_SUCCESS: 'Payment completed successfully.',
};



